import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @material-ui/core components
import Grid from "@mui/material/Grid";

function GridContainer({ ...props }) {
  const { sx, children, className, ...rest } = props;
  return (
    <Grid container {...props} sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Grid>
  );
}

GridContainer.defaultProps = {
  className: "",
};

GridContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default GridContainer;
